import { z } from 'zod';

import { WorkoutPlanId } from '../BrandedIds';
import { zodBrandedUuid } from '../utils';
import { BaseLoanIdSideEffect } from './BaseLoanIdSideEffect';

export const GenerateRepaymentPlanCancellationNoticeSideEffectContext = BaseLoanIdSideEffect.extend({
  workoutPlanId: zodBrandedUuid<WorkoutPlanId>(),
});

export const GenerateRepaymentPlanCancellationNoticeSideEffect =
  GenerateRepaymentPlanCancellationNoticeSideEffectContext.extend({
    type: z.literal('generateRepaymentPlanCancellationNotice'),
  });
export type GenerateRepaymentPlanCancellationNoticeSideEffect = z.infer<
  typeof GenerateRepaymentPlanCancellationNoticeSideEffect
>;
